/**
 * @generated SignedSource<<7a68292ff14096fd47e6478afeb143ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateEconomicVerificationKeyInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createEconomicVerificationKeyMutation$variables = {
  input: CreateEconomicVerificationKeyInput;
};
export type createEconomicVerificationKeyMutation$data = {
  readonly createEconomicVerificationKey: {
    readonly key: string | null;
  } | null;
};
export type createEconomicVerificationKeyMutation = {
  variables: createEconomicVerificationKeyMutation$variables;
  response: createEconomicVerificationKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateEconomicVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createEconomicVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createEconomicVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createEconomicVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a691a89ff34bc7f913271afd8a233212",
    "id": null,
    "metadata": {},
    "name": "createEconomicVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createEconomicVerificationKeyMutation(\n  $input: CreateEconomicVerificationKeyInput!\n) {\n  createEconomicVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();

(node as any).hash = "914545c58642fdbb15b682128759df80";

export default node;
